import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_DIALOG_SIZES = {
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
  Fullscreen: "fullscreen",
} as const;

export const DS_DIALOG_TYPES = {
  Modal: "modal",
  Dialog: "dialog",
} as const;

export type DSDialogType = (typeof DS_DIALOG_TYPES)[keyof typeof DS_DIALOG_TYPES];

export const DS_DIALOG_POSITIONS = {
  Center: "center",
  TopLeft: "top-left",
  TopCenter: "top-center",
  TopRight: "top-right",
  BottomLeft: "bottom-left",
  BottomCenter: "bottom-center",
  BottomRight: "bottom-right",
} as const;

export type DSDialogPosition = (typeof DS_DIALOG_POSITIONS)[keyof typeof DS_DIALOG_POSITIONS];
